import { FC } from "react";
import { Flex } from "@chakra-ui/react";
import { ConsultationCard } from "./ConsultationCard";
import type { Consultation } from "sdk/consultations";

interface Props {
  consultations: Consultation[];
}

export const ConsultationCards: FC<Props> = ({ consultations }) => {
  return (
    <Flex direction="column" gap={4} w="full">
      {consultations.map((consultation) => (
        <ConsultationCard
          key={consultation.id}
          consultation={consultation}
        />
      ))}
    </Flex>
  );
};
